import { makeStyles } from '@material-ui/core/styles';

export const useAISearchStyles = makeStyles(theme => ({
  aiSearchContainer: {
    width: '100%',
    position: 'relative',
    marginBottom: theme.spacing(2),
    '&:hover $buttonsWrapper': {
      opacity: 1
    }
  },
  buttonsWrapper: ({ isSettingsOpen }) => ({
    position: 'absolute',
    top: theme.spacing(0.5),
    right: theme.spacing(0.5),
    opacity: isSettingsOpen ? 1 : 0,
    transition: 'opacity 0.2s',
    '& .MuiIconButton-root': {
      backgroundColor: theme.palette.background.paper,
      boxShadow: theme.shadows?.[1] ?? 'none'
    }
  })
}));
